import { defineComponent } from "vue";

export default defineComponent({
  props: {
    badge: Number,
  },
});
